import { fetchApi } from '../client';

/** Per-clinic patient-engagement settings (appointment reminders + follow-up recall). */
export interface EngagementSettings {
  remindersEnabled: boolean;
  reminderLeadHours: number;
  recallEnabled: boolean;
  recallLeadDays: number;
}

/** Per-clinic patient-portal online-booking settings. */
export interface OnlineBookingSettings {
  onlineBookingEnabled: boolean;
  /** 0–72: patients may cancel/reschedule online until this many hours before the visit (0 = any time before it). */
  patientChangeCutoffHours?: number;
  requestExpiryHours: number;
  /** Confirm online bookings instantly when the slot is free, instead of holding them as requests for staff. */
  autoConfirm?: boolean;
  /** 0–1440: how far ahead a patient must book online (the front desk can always book). Defaults 30 / 60. */
  minNoticeMinutesInPerson?: number;
  minNoticeMinutesVideo?: number;
}

/** Rolling dispatch stats for the engagement dashboard. */
export interface EngagementStats {
  windowDays: number;
  remindersSent: number;
  recallsSent: number;
  failures: number;
}

export const engagementModule = {
  getSettings: () =>
    fetchApi<EngagementSettings>('/api/engagement/settings'),

  updateSettings: (settings: EngagementSettings) =>
    fetchApi<EngagementSettings>('/api/engagement/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    }),

  getStats: () =>
    fetchApi<EngagementStats>('/api/engagement/stats'),

  getOnlineBookingSettings: () =>
    fetchApi<OnlineBookingSettings>('/api/online-booking/settings'),

  updateOnlineBookingSettings: (settings: OnlineBookingSettings) =>
    fetchApi<OnlineBookingSettings>('/api/online-booking/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
    }),

  // WhatsApp connection, message history and category preferences moved to
  // ../modules/whatsapp.ts (whatsAppModule) — see ClinicWhatsAppSettingsPage.
};
